
























































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import LifeLinePlate from '@/components/modules/App/Profile/LifeLinePlate.vue'
import SlideList from '@/components/modules/App/SlideList.vue'
import UiModal from '@/components/ui/UiModal.vue'
import { storeModuleName } from '@/views/App/Profile/store'
import { Deal, DealStageEnum } from '@/requests/mainApi'
import { IBookingItem } from '@/views/App/Profile/store/interfaces'
import { LifeState } from '@/views/App/Deal/store/interfaces'

interface Data {
  selectedLifeStateIndex: number
  lifeStates: Array<LifeState>
  currentStepIndex: number
  modalTitle: string
  modalText: string
}

interface Methods {
  refreshLifeLine (): void
  isStepPassed (stepNumber: number): boolean
  findStepIndex (stage: DealStageEnum): number
}

interface Computed {
  deal: Deal
  dealFlat: IBookingItem
  calculateStatusIndex: number
  calculateOverlapSize: number
  calculateProgress: number
  refModal: any
  isNoActionStage: Function
}

interface Props {}

export default Vue.extend({
  name: 'LifeLine',
  components: {
    LifeLinePlate,
    SlideList,
    UiModal
  },
  data () {
    return {
      selectedLifeStateIndex: 1,
      lifeStates: [
        {
          // Квартира забронирована.
          stages: ['booking'],
          title: this.$t('app.lifeLine.plates.flatBooked.title'),
          annotation: undefined,
          bottomText: undefined,
          fullDescription: undefined,
          isPassed: true,
          isCurrentStep: false,
          lifeLineIndex: 0,
          lifeLineLength: 0,
          plateButtonStage: undefined,
          shouldShowButton: false,
          plateColor: 'var(--main-violet)',
          backgroundAfterCompletion: require('@/assets/lifeStates/booking.jpg')
        },
        {
          // Выбор типа собственности и формы оплаты.
          stages: ['type_of_ownership', 'load_owners', 'pay_options', 'load_pay_data'],
          title: this.$t('app.lifeLine.plates.type_of_ownership.title'),
          annotation: this.$t('app.lifeLine.plates.type_of_ownership.annotation'),
          stepName: this.$t('app.lifeLine.plates.type_of_ownership.stepName'),
          fullDescription: this.$t('app.lifeLine.plates.type_of_ownership.desc'),
          plateColor: 'var(--main-violet)',
          backgroundAfterCompletion: require('@/assets/lifeStates/types_of_ownership.jpg'),
          backgroundAfterCompletionMin: require('@/assets/lifeStates/types_of_ownership_min.jpg')
        },
        {
          // Проверка документов.
          stages: ['send_deal_data'],
          title: this.$t('app.lifeLine.plates.docsCheck.title'),
          annotation: this.$t('app.lifeLine.plates.docsCheck.annotation'),
          fullDescription: this.$t('app.lifeLine.plates.docsCheck.desc'),
          plateColor: '#819bff',
          backgroundAfterCompletion: require('@/assets/lifeStates/send_deal_data.jpg'),
          backgroundAfterCompletionMin: require('@/assets/lifeStates/send_deal_data_min.jpg')
        },
        {
          // Согласование договора.
          stages: ['agreement'],
          title: this.$t('app.lifeLine.plates.agreement.title'),
          annotation: this.$t('app.lifeLine.plates.agreement.annotation'),
          stepName: this.$t('app.lifeLine.plates.agreement.stepName'),
          fullDescription: this.$t('app.lifeLine.plates.agreement.desc'),
          plateColor: '#ffb622',
          backgroundAfterCompletion: require('@/assets/lifeStates/agreement.jpg'),
          backgroundAfterCompletionMin: require('@/assets/lifeStates/agreement_min.jpg')
        },
        {
          // Подписание договора.
          stages: ['signing_options', 'check_contract_signed'],
          title: this.$t('app.lifeLine.plates.signing_options.title'),
          annotation: this.$t('app.lifeLine.plates.signing_options.annotation'),
          stepName: this.$t('app.lifeLine.plates.signing_options.stepName'),
          fullDescription: this.$t('app.lifeLine.plates.signing_options.desc'),
          plateColor: '#ff535b',
          backgroundAfterCompletion: require('@/assets/lifeStates/signing_options.jpg'),
          backgroundAfterCompletionMin: require('@/assets/lifeStates/signing_options_min.jpg')
        },
        {
          // Оплата госпошлины.
          stages: ['pay_state_duty'],
          title: this.$t('app.lifeLine.plates.pay_state_duty.title'),
          annotation: this.$t('app.lifeLine.plates.pay_state_duty.annotation'),
          fullDescription: this.$t('app.lifeLine.plates.pay_state_duty.desc'),
          plateColor: 'lightblue',
          backgroundAfterCompletion: require('@/assets/lifeStates/pay_state_duty.jpg'),
          backgroundAfterCompletionMin: require('@/assets/lifeStates/pay_state_duty_min.jpg')
        },
        {
          // Регистрация в Росреестре.
          stages: ['transaction'],
          title: this.$t('app.lifeLine.plates.transaction.title'),
          annotation: this.$t('app.lifeLine.plates.transaction.annotation'),
          fullDescription: this.$t('app.lifeLine.plates.transaction.desc'),
          plateColor: '#a158ee',
          backgroundAfterCompletion: require('@/assets/lifeStates/transaction.jpg'),
          backgroundAfterCompletionMin: require('@/assets/lifeStates/transaction_min.jpg')
        },
        {
          // Оплата по договору.
          stages: ['pay_under_contract'],
          title: this.$t('app.lifeLine.plates.pay_under_contract.title'),
          annotation: this.$t('app.lifeLine.plates.pay_under_contract.annotation'),
          fullDescription: this.$t('app.lifeLine.plates.pay_under_contract.desc'),
          plateColor: '#3dd7bf',
          backgroundAfterCompletion: require('@/assets/lifeStates/pay_under_contract.jpg'),
          backgroundAfterCompletionMin: require('@/assets/lifeStates/pay_under_contract_min.jpg')
        },
        {
          // Успешная покупка.
          stages: ['final'],
          title: this.$t('app.lifeLine.plates.final.title'),
          annotation: this.$t('app.lifeLine.plates.final.annotation'),
          stepName: this.$t('app.lifeLine.plates.final.stepName'),
          plateIsHidden: true,
          fullDescription: undefined,
          plateColor: undefined
        }
      ],
      currentStepIndex: -1,
      infoModalStatus: false,
      modalTitle: '',
      modalText: ''
    }
  },
  computed: {
    lifeLinePlates () {
      return this.lifeStates.filter(state => !state.plateIsHidden)
    },
    calculateStatusIndex () {
      return this.findStepIndex(this.deal.stage!)
    },
    calculateOverlapSize () {
      return 100 / (this.lifeStates.length - 1)
    },
    getOverlapSizeInPercents () {
      return this.calculateOverlapSize + '%'
    },
    calculateProgress () {
      const length = this.lifeStates.length - 1
      const percents = this.calculateOverlapSize * this.calculateStatusIndex
      const pixels = length - length * (percents / 100)
      return `calc(${percents}% + ${pixels}px)`
    },
    dealFlat () {
      return this.deal.estate
    },
    refModal () {
      return this.$refs.modal as any
    },
    modalTextParagraphs () {
      return this.modalText.split('\n')
    },
    ...mapGetters(['isNoActionStage', 'deal'])
  },
  watch: {
    deal (val: Deal) {
      this.refreshLifeLine()
    }
  },
  created () {
    this.refreshLifeLine()
  },
  mounted () {
    const plateWidth = 211
    const plateMargin = 16;
    (this.$refs.mobileWrapper as Element).scrollLeft = this.currentStepIndex * (plateWidth + plateMargin)
  },
  methods: {
    onPlateHover (plate: LifeState) {
      this.selectedLifeStateIndex = this.findStepIndex(plate.stages[0])
    },
    refreshLifeLine () {
      Object.assign(this.$data, (this.$options.data! as any).apply(this))
      this.lifeStates[0].annotation = this.$t('app.lifeLine.plates.flatBooked.annotation', this.dealFlat)
      this.lifeStates[0].bottomText = this.dealFlat.complexTitle
      this.currentStepIndex = this.findStepIndex(this.deal.stage!)
      this.selectedLifeStateIndex = this.currentStepIndex
      for (let i = 0; i < this.lifeStates.length; i++) {
        this.lifeStates[i].isPassed = this.isStepPassed(i)
        this.lifeStates[i].isCurrentStep = this.currentStepIndex === i
        this.lifeStates[i].lifeLineIndex = i
        this.lifeStates[i].lifeLineLength = this.lifeStates.length
        if ((i === this.currentStepIndex && !this.isNoActionStage(this.lifeStates[i].plateButtonStage))) {
          this.lifeStates[i].plateButtonStage = this.deal.stage
        }
        if (this.lifeStates[i].stages[0] === DealStageEnum.Agreement &&
        (this.deal.stage === DealStageEnum.SigningOptions ||
        this.deal.stage === DealStageEnum.CheckContractSigned)) {
          this.lifeStates[i].plateButtonStage = DealStageEnum.Agreement
        }
      }
    },
    onModalOpen (title: string, fullText: string) {
      if (!fullText) return
      this.modalTitle = title
      this.modalText = fullText
      this.refModal.open()
    },
    isStepPassed (stepNumber: number) {
      this.currentStepIndex = this.findStepIndex(this.deal.stage!)
      return this.currentStepIndex > stepNumber
    },
    findStepIndex (stage: string) {
      const lifeStatesMapped = this.lifeStates.map(lifeState => lifeState.stages)
      for (let i = 0; i < lifeStatesMapped.length; i++) {
        for (let j = 0; j < lifeStatesMapped[i].length; j++) {
          if (stage === lifeStatesMapped[i][j]) {
            return i
          }
        }
      }
      return 0
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
